"use client";
import ExpandableAccordion, {
  ExpandableAccordionProps,
} from "@cc/expandable-accordion";
import SectionWrapper from "@cc/section-wrapper";

export interface AreasOfWorkProps {
  data: {
    title: string;
    initiatives: ExpandableAccordionProps["data"];
  };
}

const AreasOfWork = (props: AreasOfWorkProps) => {
  const { data } = props;
  const { title, initiatives } = data;
  return (
    <SectionWrapper
      SectionProps={{
        sx: {
          background: (theme) => theme.palette.gradient.lightToDark,
        },
      }}
      SectionHeaderProps={{
        title,
      }}
      color={"secondary.main"}
    >
      <ExpandableAccordion
        data={initiatives}
        disableMoreBtn
        flexibleAccordion
      />
    </SectionWrapper>
  );
};

export default AreasOfWork;
